import { Box, Container } from '@chakra-ui/react';
import { deleteCookie } from 'cookies-next';
import { GetServerSidePropsContext, NextPage } from 'next';
import { useState } from 'react';
import { FormattedMessage, useIntl } from 'react-intl';

import { withCommonServerSideProps } from '@/lib/withCommonServerSideProps';

import { H1 } from '@/components/Heading';
import { RegisterComplete } from '@/components/Register';
import RegisterUserForm from '@/components/Register/RegisterUserForm';
import Seo from '@/components/Seo';

import { CookieKeys } from '@/constants/cookie-keys';

const Register: NextPage = () => {
    const intl = useIntl();

    const onRegisterSubmit = () => {
        sessionStorage.removeItem('sponsorNo');
    };

    return (
        <Container maxW="5xl">
            <Seo templateTitle={intl.formatMessage({ id: 'page.register.title' })} />
            <Box py={4}>
                <H1 textAlign="center">
                    <FormattedMessage id="page.register.title"></FormattedMessage>
                </H1>
                <RegisterUserForm onRegisterSubmit={onRegisterSubmit} />
            </Box>
        </Container>
    );
};

export const getServerSideProps = withCommonServerSideProps(
    async (context: GetServerSidePropsContext) => {
        const { req, res } = context;
        deleteCookie(CookieKeys.showLoginDisabledPopup, { req, res });
        return {
            props: {}
        };
    }
);

export default Register;
